module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "ack-title"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "fig-ack"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ack-line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ack-para"
  }, [_vm._v("Marguerite Patten would like to thank the following people for their helpful information:")]), _vm._v(" "), _c('p', {
    staticClass: "ack-para"
  }, [_vm._v("The Tea Council Ltd"), _c('br'), _vm._v("Dominic Beddard, Wilson Smithett & Co, Tea Brokers"), _c('br'), _vm._v("R Twining and Company Ltd"), _c('br'), _vm._v("Miss G A Holloway, Chief Home Economist, The Flour Advisory Bureau Ltd"), _c('br'), _vm._v("Suranja Cooradia, Novosti Press Agency"), _c('br'), _vm._v("The Tea Board of India"), _c('br'), _vm._v("D R Collard, The Anglo-Arab Association"), _c('br'), _vm._v("Simon Halewood, Promotion and Public Relations Manager, Japan National"), _c('br'), _vm._v("Tourist Organization"), _c('br'), _vm._v("Chinese Embassy"), _c('br'), _vm._v("Moroccan Tourist Office")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580bcae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 66
// module chunks = 0